<template>
  <div>
    <div class="dibu" style="opacity: 0">
      <div class="bottom-tab">
        <div class="bottom-tab">
          <!-- <span>
            <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >版权所有：天津建协企业管理有限公司</a
          > -->
          <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >主 办：天津建协企业管理有限公司</a
          >
          <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >备 案 号：津ICP备2024016517号-1</a
          >
          </span>
        </div>
      </div>
    </div>
    <div
      class="dibu"
      style="position: fixed; bottom: 0px; left: 0px; right: 0px"
    >
      <div class="bottom-tab">
        <span>
          <!-- <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >版权所有：天津建协企业管理有限公司</a
          > -->
          <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >主 办：天津建协企业管理有限公司</a
          >
          <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
            >备 案 号：津ICP备2024016517号-1</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bottom-tab {
  width: 100%;
  height: 70px;
  background: #5b5e63;
  background: #efefef;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  color: #ffffff;
  /* margin-top: 101px; */
}
.as {
  color: #4d4c4c;
  text-decoration: none;
  padding: 5px 10px;
  box-sizing: border-box;
}
.as:hover {
  color: #000000;
}
</style>
